@if (status() === 'loading') {
  <div class="oo-spinner-container">
    <mat-spinner [diameter]="diameter()"></mat-spinner>
  </div>
}

@if (status() === 'error') {
  <div class="oo-error-message">
    <span>{{ errorMessage() }}</span>
  </div>
}

@if (status() !== 'error' && status() !== 'loading') {
  <div class="oo-content">
    <!-- this is a dirty hack to prevent hydration bug which caused the ui to be duplicated -->
    <ng-content></ng-content>
    <!-- this is a dirty hack to prevent hydration bug which caused the ui to be duplicated -->
    <ng-template [ngTemplateOutlet]="detailRef()!"></ng-template>
  </div>
}
